<template>
  <div>
    <section>
      <div class="mt-3">
        <div class="mtop">
          <div role="tablist">
            <template>
              <div class="text-center" v-if="isHave === false">
                <h3>Anda tidak memiliki pengajuan produk</h3>
                <h3>{{ textPengajuan }}</h3>

                <b-button v-if="!showProductOptions && isFill" @click="showProductOptions = true" variant="primary">
                  Lihat Produk
                </b-button>

                <div v-if="showProductOptions" class="mt-3">
                  <b-button href="/list-produk-deposito" variant="success" class="mr-2">Deposito</b-button>
                  <b-button href="/list-produk-tabungan" variant="info">Tabungan</b-button>
                  <div class="mt-3">
                    <b-button variant="danger" @click="showProductOptions = false" style="background-color: transparent; border: transparent;">❌</b-button>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="isLoading || isLoadingChangePage">
              <b-card no-body class="mb-2" v-for="n in 5" :key="n">
                <b-card-header class="p-3 d-flex justify-content-between align-items-center">
                  <!-- text kiri -->
                  <div class="skeleton" style="width: 60%; height: 20px;"></div>
                  <!-- tombol kanan -->
                  <div class="skeleton" style="width: 40px; height: 40px; border-radius: 6px;"></div>
                </b-card-header>
              </b-card>
            </div>
            <div v-else>
              <b-card no-body class="mb-1" v-for="(item, index) in items" :key="item.index">
                <b-card-header header-tag="header" class="p-3" role="tab">
                  <span class="m-1">{{ item.product.nama_produk }} -
                    {{ item.product.sub_product_category.name }}</span>
                    <span v-if="item.status_pengajuan_id == 9" style="background-color: red; color: white; border-radius: 4px; padding: 2px 6px; font-size: 12px;">
                      Perlu Tanda Tangan
                    </span>
                  <b-button v-b-toggle="'acc-' + item.id" variant="yellow" class="chevron mb-5">
                    <span class="when-open">
                      <b-icon icon="chevron-up" />
                    </span>
                    <span class="when-closed">
                      <b-icon icon="chevron-down" />
                    </span>
                  </b-button>
                </b-card-header>
  
                <b-collapse :id="'acc-' + item.id" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="row">
                      <div class="col-3">
                        <div class="img-fluid">
                          <img :src="getImageUrl(item)" class="card-img-top w-100 pt-3" alt="..." />
                        </div>
                      </div>
                      <div class="col-9 d-flex justify-content-end align-items-start">
                        <button 
                          class="btn btn-small btn-success" 
                          @click="downloadDocument(item)"
                          :disabled="isDownloadProcess">
                          {{ isDownloadProcess ? "Memproses..." : "Lihat Dokumen" }}
                        </button>
                        <button 
                          class="btn btn-small btn-success" 
                          @click="handleviewsignPdfToSign(item)"
                          :disabled="isSignProcess"
                          v-if="item.status_pengajuan_id == 9">
                          {{ isSignProcess ? "Memproses..." : "Tandatangani" }}
                        </button>
                        <button 
                          class="btn btn-small btn-danger" 
                          @click="changeStatus(item)"
                          v-if="!item.latest_payment_confirmation && item.status_pengajuan.id != 7 && item.status_pengajuan.id != 8 && item.status_pengajuan.id != 4 && item.status_pengajuan.id != 5">
                          Batalkan
                        </button>
                        <button class="btn btn-small btn-danger" @click="receivedDocument(item)" v-if="
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved' &&
                          item.document &&
                          item.document.status == 'mitra_uploaded'
                        ">
                          Konfirmasi Penerimaan Dokumen
                        </button>
                        <button class="btn btn-small btn-danger" @click="uploadReturnResi(item)" v-if="
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved' &&
                          item.is_overduedate &&
                          item.document &&
                          item.document.status == 'funder_received'
                        ">
                          Unggah Resi Pengembalian Dokumen
                        </button>
                        <button class="btn btn-small btn-danger" @click="konfirmasiPenerimaanDana(item)" v-if="
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved' &&
                          item.is_overduedate &&
                          item.document &&
                          item.document.status == 'mitra_received' &&
                          !item.is_lunas
                        ">
                          Konfirmasi Penerimaan Dana
                        </button>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <h3 class="mt-3">{{ item.product.nama_produk }}</h3>
                      </div>
                    </div>
                    <b-alert v-if="item.is_overduedate" variant="warning" show class="alert-warning">
                      <h4 class="alert-heading">
                        Deposito Sudah Memasuki Jatuh Tempo!
                      </h4>
                      <p class="mt-3" style="font-size: 11px;">
                        Harap segera kirimkan bilyet fisik ke BPR tujuan
                        menggunakan amplop baru. Pastikan bilyet ditujukan kepada:
                        <strong>
                          {{
                            (item &&
                              item.mitra &&
                              item.mitra.mitra_contact &&
                              item.mitra.mitra_contact
                                .nama_organisasi_perusahaan) ||
                            ""
                          }} </strong>, {{ item.mitra.mitra_profile.alamat_mitra }},
                        {{
                          (locationNames[ item.mitra.mitra_profile.id ] &&
                            locationNames[ item.mitra.mitra_profile.id ]
                              .provinsi) ||
                          ""
                        }},
                        {{
                          (locationNames[ item.mitra.mitra_profile.id ] &&
                            locationNames[ item.mitra.mitra_profile.id ].kota) ||
                          ""
                        }},
                        {{
                          (locationNames[ item.mitra.mitra_profile.id ] &&
                            locationNames[ item.mitra.mitra_profile.id ]
                              .kecamatan) ||
                          ""
                        }},
                        {{
                          (locationNames[ item.mitra.mitra_profile.id ] &&
                            locationNames[ item.mitra.mitra_profile.id ]
                              .kelurahan) ||
                          ""
                        }}. Setelah pengiriman selesai, silakan unggah nomor resi
                        pengiriman sebagai bukti pengiriman.
                      </p>
                    </b-alert>
                    <div class="row" v-if="item.product.product_category_id == 1">
                      <div class="col-12">
                        <div class="d-flex align-items-center justify-content-between px-3 py-2"
                          style="background-color: #f0f0f0; border-radius: 10px;">
                          <h4>Automatic Roll Over (ARO)</h4>
                          <div class="d-flex align-items-center">
                            <b-icon :icon="item.is_active_aro ? 'toggle-on' : 'toggle-off'
                              " scale="3" :variant="item.is_active_aro ? 'success' : 'danger'"
                              @click="toggleAro(item)"></b-icon>
                            <span class="ml-3" :style="{
                              color: item.is_active_aro ? 'green' : 'red',
                              fontWeight: 'bold',
                              fontSize: 'small'
                            }">
                              {{ item.is_active_aro ? "Aktif" : "Tidak Aktif" }}
                            </span>
                          </div>
                          <div style="background-color: #ffffcc; border-radius: 10px; padding: 5px 10px;">
                            <p class="mb-0" style="font-size: 12px;">
                              Perubahan ARO Maksimal pada
                              <strong style="color: #ffa500;">
                                "{{ getDatePlusSeven(item.due_date_aro) }}"
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div class="mt-3 px-3 py-2" style="background-color: #f0f0f0; border-radius: 10px;">
                          <p class="mt-3" style="font-size: 11px;">
                            Automatic Roll Over (ARO) atau Perpanjang Otomatis
                            adalah fitur untuk memperpanjang langsung deposito
                            Anda tanpa harus pengajuan lagi dengan nominal dan
                            tenor yang sama. Tetapi, nisbah bagi hasil akan
                            dikirimkan setelah jatuh tempo.
                          </p>
                        </div>
                      </div>
                    </div>
  
                    <table class="table mt-3">
                      <tbody>
                        <tr>
                          <td>ID Pengajuan:</td>
                          <td>{{ item.id }}</td>
                        </tr>
                        <tr>
                          <td>Tanggal Pengajuan:</td>
                          <td>{{ formattedCreatedAt(item.created_at) }}</td>
                        </tr>
                        <tr>
                          <td>Status Pengajuan:</td>
                          <td>
                            <span v-if="item.status_pengajuan.id == 9" v-bind:style="{ color: 'orange' }">Menunggu Proses Tanda Tangan</span>
                            <span v-else-if="item.status_pengajuan.id == 1" v-bind:style="{ color: 'orange' }">Menunggu Konfirmasi Admin</span>
                            <span v-else-if="item.status_pengajuan.id == 13" v-bind:style="{ color: 'orange' }">Menunggu Konfirmasi Admin</span>
                            <span v-else-if="item.status_pengajuan.id == 2" v-bind:style="{ color: 'orange' }">Menunggu Konfirmasi</span>
                            <span v-else-if="[3, 10, 11].includes(item.status_pengajuan.id)" v-bind:style="{ color: 'orange' }">Diproses</span>
                            <span v-else-if="item.status_pengajuan.id == 4" v-bind:style="{ color: 'red' }">Ditolak Admin</span>
                            <span v-else-if="item.status_pengajuan.id == 5" v-bind:style="{ color: 'red' }">Dibatalkan Mitra</span>
                            <span v-else-if="
                              (item.status_pengajuan.id == 6 &&
                                !item.latest_payment_confirmation) ||
                              (item.status_pengajuan.id == 6 &&
                                item.latest_payment_confirmation &&
                                item.latest_payment_confirmation.status !=
                                'approved')
                            " v-bind:style="{ color: 'teal' }">Disetujui</span>
                            <span v-else-if="
                              item.status_pengajuan.id == 6 &&
                              item.mitra_bank &&
                              item.latest_payment_confirmation &&
                              item.latest_payment_confirmation.status ==
                              'approved' &&
                              !item.is_overduedate
                            " v-bind:style="{ color: 'teal' }">Aktif</span>
                            <span v-else-if="item.status_pengajuan.id == 7" v-bind:style="{ color: 'orange' }">Menunggu
                              Konfirmasi Pembatalan Admin</span>
                            <span v-else-if="item.status_pengajuan.id == 8"
                              v-bind:style="{ color: 'red' }">Dibatalkan</span>
                            <span v-else-if="
                              item.status_pengajuan.id == 6 &&
                              item.mitra_bank &&
                              item.latest_payment_confirmation &&
                              item.latest_payment_confirmation.status ==
                              'approved' &&
                              item.is_overduedate &&
                              !item.is_lunas
                            " v-bind:style="{ color: 'teal' }">Selesai</span>
                            <span v-else-if="
                              item.status_pengajuan.id == 6 &&
                              item.mitra_bank &&
                              item.latest_payment_confirmation &&
                              item.latest_payment_confirmation.status ==
                              'approved' &&
                              item.is_overduedate &&
                              item.is_lunas
                            " v-bind:style="{ color: 'green' }">Lunas</span>
                            <span v-else>Tidak diketahui</span>
                          </td>
                        </tr>
                        <tr v-if="item.status_pengajuan.id == 4 && isRevised(item)">
                          <td colspan="2">
                            <b-alert show variant="danger" class="mt-2 alert-rejection">
                              <h4 class="alert-heading rejection-heading"><b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>Berdasarkan hasil verifikasi, pengajuan saat ini belum dapat disetujui.</h4>
                              <p class="mb-1 rejection-text"><strong>Alasan:</strong> {{ item.alasan_pembatalan || '-' }}</p>
                              <div v-if="getMissingFields().length > 0">
                                <p class="mb-1 rejection-text"><strong>Data atau informasi yang memerlukan perbaikan:</strong></p>
                                <div class="d-flex flex-wrap gap-2 mb-2">
                                  <b-badge
                                    v-for="(field, index) in getMissingFields()"
                                    :key="`missing-${index}`"
                                    variant="outline-secondary"
                                    class="mr-1 mb-1 badge-rejection">
                                    {{ formatFieldLabel(field) }}
                                  </b-badge>
                                </div>
                                <p class="mt-2 rejection-text font-weight-bold" style="font-size: 12px;">
                                  <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
                                  Silahkan perbarui profil Anda pada bagian yang disebutkan di atas agar dapat melakukan pengajuan kembali.
                                </p>
                              </div>
                              <div v-else>
                                <p class="mt-1 mb-0" style="font-size: 12px; color: #155724;">
                                  <b-icon icon="check-circle-fill" class="mr-1"></b-icon>
                                  Semua data sudah dilengkapi. Menunggu verifikasi ulang dari admin.
                                </p>
                              </div>
                            </b-alert>
                          </td>
                        </tr>
                        <tr v-if="
                          item.status_pengajuan.id == 6 &&
                          item.mitra_bank &&
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved'
                        ">
                          <td>Tanggal Pengajuan Aktif:</td>
                          <td>{{ formattedCreatedAt(item.started_at) }}</td>
                        </tr>
                        <tr v-if="
                          item.product.product_category_id == 1 &&
                          item.status_pengajuan.id == 6 &&
                          item.mitra_bank &&
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved'
                        ">
                          <td>Tanggal Jatuh Tempo:</td>
                          <td>{{ formattedCreatedAt(item.due_date) }}</td>
                        </tr>
                        <tr>
                          <td>Setoran Awal:</td>
                          <td>{{ formatCurrency(item.setoran_awal) }}</td>
                        </tr>
  
                        <tr v-if="
                          (item.status_pengajuan.id == 6 && item.mitra_bank && !item.latest_payment_confirmation) ||
                          (item.status_pengajuan.id == 6 && item.mitra_bank && item.latest_payment_confirmation.status == 'rejected')
                        ">
                          <td>Mohon untuk transfer ke rekening:</td>
                          <td>
                            {{ item.mitra_bank.bank.name }}<br />{{
                              item.mitra_bank.account_number
                            }}<br />AN: {{ item.mitra_bank.account_name }}
                          </td>
                        </tr>
  
                        <tr v-if="
                          item.status_pengajuan.id == 6 &&
                          item.mitra_bank &&
                          !item.latest_payment_confirmation
                        ">
                          <td>Status Pembayaran:</td>
                          <td>Menunggu Unggah Bukti Pembayaran</td>
                        </tr>
  
                        <tr v-if="
                          item.status_pengajuan.id == 6 &&
                          item.mitra_bank &&
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status == 'pending'
                        ">
                          <td>Status Pembayaran:</td>
                          <td>Menunggu Konfirmasi Mitra</td>
                        </tr>
  
                        <tr v-if="
                          item.status_pengajuan.id == 6 &&
                          item.mitra_bank &&
                          item.latest_payment_confirmation &&
                          item.latest_payment_confirmation.status ==
                          'approved'
                        ">
                          <td>Status Pembayaran:</td>
                          <td>Pembayaran Diterima</td>
                        </tr>
  
                        <tr v-if="
                          (item.status_pengajuan.id == 6 &&
                            !item.latest_payment_confirmation) ||
                          (item.status_pengajuan.id == 6 &&
                            item.latest_payment_confirmation.status ==
                            'rejected')
                        ">
                          <td colspan="2" class="text-center">
                            <b-button variant="success" @click="openUploadModal(item)">Unggah Bukti Pembayaran</b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <hr />
                    <div v-if="
                      item.status_pengajuan.id == 6 &&
                      item.mitra_bank &&
                      item.latest_payment_confirmation &&
                      item.latest_payment_confirmation.status == 'approved' &&
                      item.document && 
                      item.document.status != 'funder_received' &&
                      item.document.status != 'mitra_received' && 
                      item.document.status != 'funder_uploaded'
                    " class="row mt-3">
                      <div class="col-6">
                        <div v-if="item.product.product_category_id == 1" class="text-center">
                          <h6>Gambar Bilyet</h6>
                          <div class="image-container">
                            <img :src="getBilyetUrl(item)" class="img-thumbnail img-fluid fixed-size"
                              alt="Gambar bilyet" />
                          </div>
                          <h6>Nomor Bilyet : {{ item.document.nomor_bilyet }}</h6>
                        </div>
                        <div v-else class="text-center">
                          <h6>Gambar Rekening</h6>
                          <div class="image-container">
                            <img :src="getBilyetUrl(item)" class="img-thumbnail img-fluid fixed-size"
                              alt="Gambar rekening" />
                          </div>
                          <h6>
                            Nomor Rekening : {{ item.document.nomor_bilyet }}
                          </h6>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="text-center">
                          <h6>Gambar Resi</h6>
                          <div class="image-container">
                            <img :src="getResiUrl(item)" class="img-thumbnail img-fluid fixed-size" alt="Gambar Resi" />
                          </div>
                          <h6>Nomor Resi : {{ item.document.nomor_resi }}</h6>
                        </div>
                      </div>
                    </div>
                    <!-- Modal Konfirmasi Pembatalan -->
                    <b-modal size="sm" v-model="confirmStatusModal" hide-footer hide-header>
                      <div class="d-block text-center">
                        <h3>{{ modalTitle }}</h3>
                      </div>
                      <div v-if="!changingStatus" class="row">
                        <div class="col">
                          <b-button class="mt-3" block @click="confirmChangeStatus(item)">Ya</b-button>
                        </div>
                        <div class="col">
                          <b-button class="mt-3" block @click="confirmStatusModal = false">Tidak</b-button>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col text-center">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                      </div>
                    </b-modal>
  
                    <!-- Modal Sukses Pembatalan -->
                    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
                      <div class="d-block text-center">
                        <h3>
                          {{ successMessage }}
                        </h3>
                      </div>
                      <div v-if="!changingStatus" class="row">
                        <div class="col">
                          <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col text-center">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                      </div>
                    </b-modal>
  
                    <!-- modal konfirmasi bilyet -->
                    <b-modal size="m" v-model="received_document_modal" v-if="
                      item.document && item.document.status == 'mitra_uploaded'
                    ">
                      <div class="d-block text-center">
                        <h3>
                          Apakah anda yakin sudah menerima
                          {{
                            item.product.product_category_id == 1
                              ? "bilyet"
                              : "buku tabungan"
                          }}
                          ?<br />({{ item.product.nama_produk }} -
                          {{
                            item.mitra.mitra_contact.nama_organisasi_perusahaan
                          }})
                        </h3>
                      </div>
                      <template #modal-footer>
                        <div v-if="changingStatus" class="text-center">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                        <div v-else>
                          <b-button @click="konfirmasiReceivedDocument(item)" variant="primary">Ya</b-button>
                          <b-button @click="received_document_modal = false" variant="danger">Tidak</b-button>
                        </div>
                      </template>
                    </b-modal>
  
                    <!-- modal konfirmasi pembayaran -->
                    <b-modal size="m" v-model="modal_konfirmasi_dana" v-if="
                      item.is_overduedate &&
                      item.document &&
                      item.document.status == 'mitra_received'
                    ">
                      <div class="d-block text-center">
                        <h3>
                          Apakah anda yakin sudah menerima pengembalian dana
                          deposito?<br />({{ item.product.nama_produk }} -
                          {{
                            item.mitra.mitra_contact.nama_organisasi_perusahaan
                          }})
                        </h3>
                      </div>
                      <template #modal-footer>
                        <div v-if="changingStatus" class="text-center">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                        <div v-else>
                          <b-button @click="confirmDana(item)" variant="primary">Ya</b-button>
                          <b-button @click="modal_konfirmasi_dana = false" variant="danger">Tidak</b-button>
                        </div>
                      </template>
                    </b-modal>
  
                    <!-- Modal Unggah Bukti Pembayaran -->
                    <newCustomModal :visible="uploadModal" @close="closeModalProperly" size="large">
                      <div class="d-block text-center">
                        <h3 class="mb-3">Unggah Bukti Pembayaran</h3>
                        <hr class="mb-3" />

                        <!-- Tombol Upload -->
                        <div class="mb-3">
                          <button
                            type="button"
                            class="custom-btn primary"
                            @click="triggerFileInput"
                            :disabled="loadingUploadProof"
                          >
                            + Tambah Bukti Pembayaran
                          </button>

                          <!-- Input file native, hidden -->
                          <input
                            id="fileInputHidden"
                            type="file"
                            accept="image/*"
                            multiple
                            class="d-none"
                            @change="handleImageUpload"
                          />
                        </div>

                        <!-- Preview Box (selalu muncul) -->
                        <div
                          class="d-flex flex-wrap justify-content-center border rounded p-3"
                          style="min-height: 160px;"
                        >
                          <template v-if="form_attachment.images.length">
                            <div class="preview-wrapper d-flex flex-wrap">
                              <div
                                v-for="(img, index) in form_attachment.images"
                                :key="index"
                                class="preview-item"
                              >
                                <img :src="img" alt="preview" @click="openPreview(img)" />
                                <button type="button" class="remove-btn" @click="removeImage(index)">×</button>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="text-muted d-flex align-items-center justify-content-center w-100">
                              Belum ada bukti pembayaran yang diunggah
                            </div>
                          </template>
                        </div>

                        <!-- Tombol Aksi -->
                        <div class="modal-action-buttons no-rekening mt-3">
                          <button
                            v-if="!changingStatus"
                            type="button"
                            class="custom-btn danger"
                            @click="closeModalProperly"
                            :disabled="loadingUploadProof"
                          >
                            Tutup
                          </button>

                          <button
                            v-if="!changingStatus"
                            type="button"
                            class="custom-btn primary d-flex align-items-center justify-content-center"
                            @click.prevent="confirmAddBukti"
                            :disabled="loadingUploadProof"
                          >
                            <template v-if="loadingUploadProof">
                              <b-spinner small type="border" variant="light" class="mr-2" label="Loading..."></b-spinner>
                              Memproses...
                            </template>
                            <template v-else>
                              Unggah
                            </template>
                          </button>
                        </div>
                      </div>
                    </newCustomModal>
                    <newCustomModal :visible="previewImageModal" @close="closePreview" size="large">
                      <div class="d-flex justify-content-center align-items-center">
                        <img
                          v-if="selectedImage"
                          :src="selectedImage"
                          alt="Full Preview"
                          style="max-width: 100%; max-height: 80vh; object-fit: contain;"
                        />
                      </div>
                    </newCustomModal>
  
                    <b-modal size="md" v-model="successUploadBukti" hide-footer hide-header>
                      <div class="d-block text-center">
                        <h3>Unggah Konfirmasi Pembayaran Berhasil</h3>
                        <hr />
                        <h3>
                          Pembayaran Anda akan segera divalidasi, terima kasih!
                        </h3>
                      </div>
                      <b-button class="mt-3" block @click="successUpload">Tutup</b-button>
                    </b-modal>
  
                    <!-- Modal Upload resi pengembalian -->
                    <b-modal size="md" v-model="uploadReturnResiModal" hide-footer hide-header v-if="
                      item.is_overduedate &&
                      item.document && 
                      item.document.status == 'funder_received'
                    ">
                      <div class="d-block text-center">
                        <h3>Unggah Resi Pengembalian</h3>
                      </div>
                      <b-form @submit.prevent="handleSubmit">
                        <b-form-group label="Nomor Resi" label-for="nomor_resi">
                          <b-form-input id="nomor_resi" v-model="form_upload.nomor_resi"
                            placeholder="Masukkan Nomor Resi"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Unggah Resi" label-for="upload_resi">
                          <b-form-file id="upload_resi" v-model="form_upload.upload_resi" accept="image/*"></b-form-file>
                        </b-form-group>
                      </b-form>
                      <div v-if="!changingStatus" class="row">
                        <div class="col">
                          <b-button class="mt-3" block @click="confirmUpload">Ya</b-button>
                        </div>
  
                        <div class="col">
                          <b-button class="mt-3" block @click="uploadReturnResiModal = false">Tidak</b-button>
                        </div>
                      </div>
  
                      <!-- Jika masih dalam proses perubahan status -->
                      <div v-else class="row">
                        <div class="col text-center">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                      </div>
                    </b-modal>
                    <!-- <b-modal
                      size="lg"
                      v-model="uploadModal"
                      hide-footer
                      title="Unggah Bukti Pembayaran"
                    >
                      <b-form @submit.prevent="submitPaymentProof(item)">
                        <b-form-file
                          v-model="paymentProof"
                          accept="image/*"
                          placeholder="Pilih gambar..."
                          drop-placeholder="Drop file here..."
                          required
                        ></b-form-file>
                        <b-button variant="primary" type="submit" class="mt-3"
                          >Unggah</b-button
                        >
                      </b-form>
                    </b-modal> -->
                  </b-card-body>
                </b-collapse>
              </b-card>
              
            </div>
            <b-pagination
              class="my-0 my-lg-3"
              v-if="pagination.last_page > 1"
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              align="center"
              @input="handlePageChange"
            ></b-pagination>
          </div>
        </div>
      </div>
      <!-- Popup Iframe -->
      <div v-if="showIframe" class="popup-overlay" @click.self="closeIframe">
        <div class="popup-content">
          <button @click="closeIframe" class="close-btn">Tutup</button>
          <iframe
            :src="iframeUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allow="camera; microphone"
          ></iframe>

          <div v-if="this.$route.query.action == 'show' && opened_item" class="sign-button-wrapper">
            <button 
              class="sign-btn"
              @click="webviewAuthSign(opened_item)"
              :disabled="isSignProcess"
            >
              {{ isSignProcess ? "Memproses..." : "Tandatangani" }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <div v-if="loadingIframe" class="fullscreen-loading">
      <div class="spinner-wrapper">
        <b-spinner variant="primary" label="Loading..." style="width: 4rem; height: 4rem;"></b-spinner>
        <div class="mt-3 text-white font-weight-bold">Memuat Dokumen...</div>
      </div>
    </div>
  </div>
</template>

<script>
import Pengajuan from "../../api/pengajuan.js";
import Provinsi from "../../api/daerahindonesia/provinsi.js";
import Kota from "../../api/daerahindonesia/kota.js";
import Kecamatan from "../../api/daerahindonesia/kecamatan.js";
import Kelurahan from "../../api/daerahindonesia/kelurahan.js";
import moment from "moment";
import Funder from "../../api/funder.js";
import newCustomModal from "../../components/newCustomModal.vue";

export default {
  name: "PengajuanFunding",
  components: {
    newCustomModal
  },
  data() {
    return {
      items: [],
      locationNames: {},
      product_id: "",
      confirmStatusModal: false,
      changingStatus: false,
      successModal: false,
      successMessage: "",
      uploadModal: false,
      paymentProof: null,
      modalText: "",
      modalTitle: "",
      isHave: true,
      textPengajuan: "",
      isFill: false,
      thumbnails: [],
      successUploadBukti: false,
      form_attachment: {
        id_pengajuan: null,
        images: [] // simpan file base64 atau file asli
      },
      form_upload: {
        pengajuan_id: null,
        nomor_resi: null,
        upload_resi: null
      },
      received_document_modal: false,
      uploadReturnResiModal: false,
      modal_konfirmasi_dana_org: "",
      modal_konfirmasi_dana: false,
      isDownloadProcess: false,
      isSignProcess: false,
      showIframe: false,
      iframeUrl: "",
      opened_item: null,
      loadingIframe: false,
      showProductOptions: false,
      isFill: true,
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 10,
      },
      isLoading: false,
      isLoadingChangePage: false,
      loadingUploadProof: false,
      previewImageModal: false, 
      selectedImage: null, 
      profileUpdatedAt: null,
      unresolvedFields: [],
    };
  },
  mounted() {
    this.loadData().then(() => {
      this.handleActionFromQuery();
    });
    window.addEventListener("beforeunload", this.preventReloadOnLoading);
  },
  activated() {
    this.loadData();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventReloadOnLoading);
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    triggerFileInput() {
      document.getElementById("fileInputHidden").click();
    },
    handleImageUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = e => {
          this.form_attachment.images.push(e.target.result);
        };
        reader.readAsDataURL(files[i]);
      }
    },
    removeImage(index) {
      this.form_attachment.images.splice(index, 1);
    },
    openPreview(img) {
      this.selectedImage = img;
      this.previewImageModal = true;
    },
    closePreview() {
      this.selectedImage = null;
      this.previewImageModal = false;
    },
    addImageInput() {
      this.form_attachment.images.push({ base64: null });
    },
    preventReloadOnLoading(event) {
      if (this.loadingIframe) {
        event.preventDefault();
        event.returnValue = "Dokumen sedang dimuat. Apakah Anda yakin ingin meninggalkan halaman?";
      }
    },
    toggleAro(item) {
      // Capture the current state of is_active_aro
      const currentStatus = item.is_active_aro;
      // Immediately toggle the state locally so the switch responds instantly
      item.is_active_aro = !currentStatus;

      // Hit the API to persist the change
      Pengajuan.toggleARO(item.id)
        .then(response => {
          if (response.data.meta.code != 200) {
            item.is_active_aro = currentStatus;
            this.$bvToast.toast(response.data.meta.messages, {
              title: "Error",
              variant: "danger",
              solid: true
            });
          } else {
            this.$bvToast.toast(response.data.meta.messages, {
              title: "Success",
              variant: "success",
              solid: true
            });
          }
        })
        .catch(response => {
          // If there is an error, revert the value back
          item.is_active_aro = currentStatus;

          // Show an error message
          this.$bvToast.toast("Error updating ARO status", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        });
    },
    getDatePlusSeven(dateString) {
      if (!dateString) return ""; // Pastikan ada nilai tanggal
      const date = new Date(dateString);

      // Array nama bulan dalam bahasa Indonesia
      const bulanIndo = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ];

      // Mengambil tanggal, bulan, dan tahun
      const day = date.getDate(); // Mengambil hari
      const month = bulanIndo[ date.getMonth() ]; // Mengambil nama bulan
      const year = date.getFullYear(); // Mengambil tahun

      return `${day} ${month} ${year}`; // Mengembalikan tanggal dalam format dd Month yyyy
    },
    async handlePageChange(page) {
      this.isLoadingChangePage = true;
      await this.loadData(page);
    },

    async loadData(page = 1) {
      try {
        if (!this.isLoadingChangePage) {
          this.isLoading = true;
        }

        const res = await Pengajuan.pengajuanFunder({
          page,
          per_page: this.pagination.per_page,
        });

        this.pagination = {
          current_page: res.data.data.current_page,
          last_page: res.data.data.last_page,
          total: res.data.data.total,
          per_page: res.data.data.per_page,
        };

        this.items = res.data.data.data;
        
        this.isLoading = false;
        this.isLoadingChangePage = false;
        if (this.items && this.items.length) {
          this.isHave = true;

          await Promise.all(
            this.items.map((item) => this.loadLocationNames(item.mitra.mitra_profile))
          );
        } else {
          this.isHave = false;
        }

        const fillStatus = await Pengajuan.isFunderCompleteProfile();
        this.textPengajuan =
          fillStatus.data.meta.code === 200
            ? "Kini anda dapat melakukan pengajuan produk!"
            : fillStatus.data.meta.code === 206 ? fillStatus.data.meta.message
            : "Silahkan lengkapi profil terlebih dahulu sebelum melakukan pengajuan produk!";
        this.isFill = fillStatus.data.data === "ready";

        // Fetch unresolved rejection fields from check-rejection endpoint
        try {
          const resReject = await Pengajuan.checkRejection();
          if (resReject.data.meta.code === 200 && resReject.data.data.has_rejection) {
            this.unresolvedFields = resReject.data.data.unresolved_fields || [];
          } else {
            this.unresolvedFields = [];
          }
        } catch (e) {
          console.error('Gagal mengambil data rejection:', e);
          this.unresolvedFields = [];
        }

      } catch (error) {
        console.error("Terjadi kesalahan saat memuat data:", error);
      } finally {
        this.isLoading = false;
        this.isLoadingChangePage = false;
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0
      }).format(value);
    },
    changeStatus(item) {
      this.product_id = "";
      this.product_id = item.id;
      // console.log(item);
      this.modalTitle =
        "Apakah anda yakin ingin melakukan pengajuan pembatalan?";
      //   this.modalText = 'Anda tidak akan bisa mengembalikan status ke status sebelumnya'
      this.confirmStatusModal = true;
    },
    async downloadDocument(item) {
      this.isDownloadProcess = true
      this.closeIframe();
      try {
        const getDocumentResponse = await Pengajuan.getDocumentUrl({ pengajuan_id: item.id });
        if (getDocumentResponse.data.meta.code === 200) {
					const { url: documentUrl } = getDocumentResponse.data.data;

					// Buka di tab baru
					window.open(documentUrl, '_blank');
				} else {
					this.$bvToast.toast(getDocumentResponse.data.meta.message || "Gagal mendapatkan URL dokumen Surat Kuasa.", {
						title: "Kesalahan",
						variant: "danger",
						solid: true,
					});
				}
      } catch (error) {
        console.log('Terjadi kesalahan saat mengambil URL doukumen surat kuasa.', error)
        this.showToast("Terjadi kesalahan saat mengambil URL doukumen surat kuasa.", "Kesalahan", "danger");
      } finally {
        this.isDownloadProcess = false;
      }
    },
    async previewDocument(item) {
      this.isDownloadProcess = true
      this.loadingIframe = true;
      this.closeIframe();
      try {
        const getDocumentResponse = await Pengajuan.getDocumentUrl({ pengajuan_id: item.id });
        if (getDocumentResponse.data.meta.code === 200) {
          const documentUrl = getDocumentResponse.data.data;

          this.iframeUrl = documentUrl.url;
          this.showIframe = true;
          this.$nextTick(() => {
            setTimeout(() => {
              this.loadingIframe = false; // Hilangkan spinner setelah iframe ditampilkan
            }, 500); // kamu bisa ubah ke 1000 ms jika perlu lebih lama
          });
        } else {
          this.$bvToast.toast("Gagal mendapatkan URL dokumen Surat Kuasa.", {
            title: "Kesalahan",
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        console.log('Terjadi kesalahan saat mengambil URL doukumen surat kuasa.', error)
        this.showToast("Terjadi kesalahan saat mengambil URL doukumen surat kuasa.", "Kesalahan", "danger");
      } finally {
        this.isDownloadProcess = false;
      }
    },
    async webviewAuthSign(item) {
      this.isSignProcess = true;
      this.opened_item = null;
      this.closeIframe();

      try {
        const webviewUrl = await Pengajuan.getUrlWebviewAuthSign({
          pengajuan_id: item.id,
        });
        if (webviewUrl.data.meta.code === 200) {
          this.iframeUrl = webviewUrl.data.data;
          this.showIframe = true;
        } else {
          this.showToast(
            webviewUrl.data.meta.message || "Gagal memuat halaman tanda tangan.",
            "Kesalahan",
            "danger"
          );
        }
      } catch (error) {
        console.log('Terjadi kesalahan saat memproses tanda tangan dokumen.', error)
        this.showToast("Terjadi kesalahan saat memproses tanda tangan dokumen.", "Kesalahan", "danger");
      } finally {
        this.isSignProcess = false;
      }
    },
    handleviewsignPdfToSign(item){
      this.isSignProcess = true;
      this.opened_item = null;
      this.closeIframe();

      const targetUrl = this.$router.resolve({
        path: '/pengajuan-saya',
        query: {
          pengajuan_id: item.id,
          action: 'show'
        }
      }).href;

      window.location.href = targetUrl;
    },
    closeIframe() {
      this.showIframe = false;
      this.iframeUrl = "";
      const urlWithoutParams = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, urlWithoutParams);
    },
    showToast(message, title, variant = "default") {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    formattedCreatedAt(date) {
      return new Date(date).toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    imageChange(e, index) {
      let file = e.target.files[0];
      if (!file) return;

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = res => {
        this.$set(this.form_attachment.images, index, res.target.result); 
      };
    },
    confirmChangeStatus(item) {
      this.changingStatus = true;
      const data = {
        id: this.product_id
      };

      Pengajuan.changeReject(data)
        .then(res => {
          // console.log(res.data);
          if (res.data.meta.code == 200) {
            this.changingStatus = false;
            this.successModal = true;
            this.successMessage =
              "Pengajuan pembatalan berhasil diajukan, admin akan segera melakukan konfirmasi pembatalan anda!";
            this.loadData();
            this.confirmStatusModal = false;
          } else {
            this.changingStatus = false;
            this.confirmStatusModal = false;
          }
        })
        .catch(err => console.error(err));
    },

    openUploadModal(item) {
      this.form_attachment.id_pengajuan = item.id;
      this.uploadModal = true;
    },

    successUpload() {
      this.successUploadBukti = false;
      this.loadData();
    },
    confirmAddBukti() {
      this.loadingUploadProof = true
      const payload = {
        pengajuan_id: this.form_attachment.id_pengajuan,
        images: this.form_attachment.images
      }

      Pengajuan.uploadPaymentProofV3(payload)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.uploadModal = false
            this.loadingUploadProof = false   
            this.$toast.success('Unggah bukti pembayaran berhasil. Silahkan menunggu konfirmasi dari mitra.' || res.data.meta.message);
            this.loadData()
          } else {
            this.loadingUploadProof = false
            this.$toast.error(res.data.meta.message)
            console.error(res.data)
          }
        })
        .catch(err => {
          this.loadingUploadProof = false
          this.$toast.error(res.data.meta.message);
          console.error(err)
        })
    },
    closeModalProperly(){
      this.uploadModal = false;
      this.form_attachment = {
        id_pengajuan: null,
        images: [] 
      }
    },
    getImageUrl(item) {
      return item.mitra && item.mitra.mitra_profile
        ? item.mitra.mitra_profile.logo_mitra
        : "";
    },
    getBilyetUrl(item) {
      return item.document && item.document.upload_bilyet
        ? item.document.upload_bilyet : "";
    },
    getResiUrl(item) {
      return item.document && item.document.upload_resi
        ? item.document.upload_resi : "";
    },
    receivedDocument() {
      this.received_document_modal = true;
    },
    isRevised(item) {
      if (item.is_rejection_resolved == true) {
        return false;
      }
      return this.unresolvedFields.length > 0;
    },
    getMissingFields() {
      return this.unresolvedFields;
    },
    formatFieldLabel(f) {
      if (!f) return '';
      
      // Handle object - extract field name if it's an object
      let fieldStr = '';
      if (typeof f === 'object' && f !== null) {
        // If it's an object, try to get field_name or name property
        fieldStr = f.field_name || f.name || f.field || JSON.stringify(f);
      } else if (typeof f === 'string') {
        fieldStr = f;
      } else {
        fieldStr = String(f);
      }
      
      const fieldKey = fieldStr.toLowerCase().replace(/ /g, '_');
      
      // Special Mappings
      if (fieldKey.includes('nama_pihak_terkait') || fieldKey.includes('related_party_name')) return 'NAMA AHLI WARIS';
      if (fieldKey.includes('hubungan_pihak_terkait') || fieldKey.includes('related_party_relationship')) return 'HUBUNGAN AHLI WARIS';
      if (fieldKey.includes('no_hp_pihak_terkait') || fieldKey.includes('related_party_phone')) return 'NOMOR TELEPON AHLI WARIS';
      if (fieldKey.includes('alamat_pihak_terkait') || fieldKey.includes('related_party_address')) return 'ALAMAT AHLI WARIS';
      if (fieldKey === 'pihak_terkait') return 'AHLI WARIS';
      
      if (fieldKey === 'npwp_attachment' || fieldKey === 'taxpayer_document_path') return 'NPWP GAMBAR / PDF';
      if (fieldKey === 'alamat_terkini' || fieldKey === 'current_address') return 'ALAMAT DOMISILI';
      if (fieldKey === 'ratarata_penghasilan_perbulan' || fieldKey === 'estimated_transaction_value') return 'RATA-RATA PENGHASILAN DALAM 1 BULAN';
      if (fieldKey === 'nama_tempatkerja' || fieldKey === 'company_name') return 'NAMA TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'alamat_tempatkerja' || fieldKey === 'company_address') return 'ALAMAT TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'jabatan' || fieldKey === 'position_id') return 'JABATAN';
      if (fieldKey === 'bank_id' || fieldKey === 'bank') return 'NAMA BANK';
      if (fieldKey === 'account_number') return 'NOMOR REKENING';
      if (fieldKey === 'account_name') return 'NAMA PEMILIK REKENING';
      if (fieldKey === 'taxpayer_number' || fieldKey === 'npwp') return 'NPWP';
      if (fieldKey === 'identity_number') return 'NOMOR IDENTITAS / KTP';
      if (fieldKey === 'gender' || fieldKey === 'jenis_kelamin') return 'JENIS KELAMIN';
      if (fieldKey === 'identity_address' || fieldKey === 'alamat') return 'ALAMAT KTP';
      if (fieldKey === 'place_of_birth' || fieldKey === 'tempat_lahir') return 'TEMPAT LAHIR';
      if (fieldKey === 'date_of_birth' || fieldKey === 'tanggal_lahir') return 'TANGGAL LAHIR';
      if (fieldKey === 'nationality' || fieldKey === 'kewarganegaraan') return 'KEWARGANEGARAAN';
      
      return fieldStr.replace(/_id$/i, '').replace(/_/g, ' ').toUpperCase();
    },
    konfirmasiReceivedDocument(item) {
      this.changingStatus = true;
      const data = {
        pengajuan_id: item.id
      };

      Pengajuan.funderReceiveDocument(data)
        .then(res => {
          if (res.data.meta.code == 200) {
            this.changingStatus = false;
            this.successModal = true;
            this.successMessage =
              'Status dokumen telah berhasil diubah menjadi "Diterima Nasabah".';
            this.loadData();
            this.received_document_modal = false;
          } else {
            this.changingStatus = false;
            this.received_document_modal = false;
          }
        })
        .catch(err => console.error(err));
    },
    uploadReturnResi(item) {
      this.uploadReturnResiModal = true;
      this.form_upload.pengajuan_id = item.id;
    },
    konfirmasiPenerimaanDana(item) {
      // console.log("data", item.nama_organisasi_perusahaan);
      this.modal_konfirmasi_dana_org = item.nama_organisasi_perusahaan;
      this.modal_konfirmasi_dana = true;
    },
    isDueDateApproaching(dueDate, aro) {
      if (!dueDate) return false;
      if (aro) return false;

      const dueDateMoment = moment(dueDate);
      const today = moment();

      // Periksa apakah sudah melebihi dueDate
      if (dueDateMoment.isBefore(today)) {
        return true;
      }

      // Periksa apakah jatuh tempo dalam 7 hari ke depan
      if (dueDateMoment.isBetween(today, today.clone().add(7, "days"))) {
        return true;
      }

      return false;
    },
    async loadLocationNames(profile) {
      // Memuat nama provinsi, kota, kecamatan, dan kelurahan secara asinkron
      const [ provinsi, kota, kecamatan, kelurahan ] = await Promise.all([
        this.getProvinsi(profile.provinsi),
        this.getKota(profile.kota),
        this.getKecamatan(profile.kecamatan),
        this.getKelurahan(profile.kelurahan)
      ]);

      this.$set(this.locationNames, profile.id, {
        provinsi,
        kota,
        kecamatan,
        kelurahan
      });
    },

    async getProvinsi(id) {
      try {
        const res = await Provinsi.show(id);
        return res.data.nama || "";
      } catch (error) {
        console.error("Terjadi kesalahan saat mengambil data provinsi:", error);
        return "";
      }
    },

    async getKota(id) {
      try {
        const res = await Kota.show(id);
        return res.data.nama || "";
      } catch (error) {
        console.error("Terjadi kesalahan saat mengambil data kota:", error);
        return "";
      }
    },

    async getKecamatan(id) {
      try {
        const res = await Kecamatan.show(id);
        return res.data.nama || "";
      } catch (error) {
        console.error(
          "Terjadi kesalahan saat mengambil data kecamatan:",
          error
        );
        return "";
      }
    },

    async getKelurahan(id) {
      try {
        const res = await Kelurahan.show(id);
        return res.data.nama || "";
      } catch (error) {
        console.error(
          "Terjadi kesalahan saat mengambil data kelurahan:",
          error
        );
        return "";
      }
    },
    confirmUpload() {
      this.changingStatus = true;

      const convertToBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(new Error("Error reading file"));
          reader.readAsDataURL(file);
        });
      };

      const filePromises = [
        this.form_upload.upload_resi
          ? convertToBase64(this.form_upload.upload_resi).then(base64 => {
            this.form_upload.upload_resi = base64;
          })
          : Promise.resolve()
      ];

      Promise.all(filePromises)
        .then(() => {
          const formData = {
            pengajuan_id: this.form_upload.pengajuan_id,
            return_tracking_number: this.form_upload.nomor_resi,
            return_tracking_upload: this.form_upload.upload_resi
          };

          return Pengajuan.uploadReturnTracking(formData);
        })
        .then(res => {
          if (res.data.meta.code === 200) {
            this.uploadReturnResiModal = false;
            this.successModal = true;
            this.successMessage = "Status berhasil diubah";
            this.loadData();
          }
          this.changingStatus = false;
        })
        .catch(err => {
          console.error(err);
          this.changingStatus = false;
        });
    },
    confirmDana(pengajuan) {
      this.changingStatus = true;
      const data = {
        id: pengajuan.id
      };

      Pengajuan.changeStatusToLunas(data)
        .then(res => {
          if (res.data.meta.code == 200) {
            this.changingStatus = false;
            this.successModal = true;
            this.successMessage =
              'Status pengajuan telah berhasil diubah menjadi "LUNAS".';
            this.loadData();
            this.modal_konfirmasi_dana = false;
          } else {
            this.changingStatus = false;
            this.modal_konfirmasi_dana = false;
          }
        })
        .catch(err => console.error(err));
    },
    handleActionFromQuery() {
      const pengajuanId = this.$route.query.pengajuan_id;
      const action = this.$route.query.action;

      if (!pengajuanId || !action) return;

      const item = this.items.find((item) => item.id == pengajuanId);
      if (!item) {
        this.showToast("Pengajuan tidak ditemukan.", "Gagal", "danger");
        return;
      }

      if (action === "sign") {
        this.webviewAuthSign(item);
      } else if (action === "show") {
        this.opened_item = item;
        this.previewDocument(item);
      }
    }
  }
};
</script>

<style scoped>
.badge-outlined {
  background-color: transparent !important;
  border: 1px solid #6c757d;
  color: #343a40 !important;
  padding: 4px 8px !important;
  font-weight: 500;
}

.alert-rejection {
  background-color: #ffffff !important;
  border: 1.5px solid #e08080 !important;
  border-left: 4px solid #c0392b !important;
  color: #c0392b !important;
}

.rejection-heading {
  color: #c0392b !important;
  font-size: 15px;
}

.rejection-text {
  color: #c0392b !important;
}

.badge-rejection {
  background-color: #ffe4e4 !important;
  border: 1px solid #e08080 !important;
  color: #c0392b !important;
  padding: 4px 10px !important;
  font-weight: 500;
  border-radius: 4px;
}

.skeleton {
  background: #e0e0e0;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150px;
  height: 50%;
  width: 150px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.6),
    transparent
  );
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  0% {
    left: -150px;
  }
  100% {
    left: 100%;
  }
}
.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}

.image-container {
  width: 300px;
  height: 300px;
  overflow: hidden;
  display: flex;              
  justify-content: center;    
  align-items: center;        
  margin: 0 auto;             
}
.fixed-size {
  width: 100%;
  height: 100%;
  object-fit: contain;        
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.popup-content {
  background: white;
  width: 90%;
  height: 90%;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.popup-content iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.open-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: green;
  color: white;
  border: none;
  padding: 5px 12px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  z-index: 10;
  transition: background 0.3s ease;
}

.open-btn:hover {
  background: darkgreen;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  z-index: 10;
}

.close-btn:hover {
  background: darkred;
}

.sign-button-wrapper {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none; /* biar iframe tetap bisa klik, hanya tombol yang bisa */
}

.sign-btn {
  pointer-events: all;
  background: #28a745; /* Hijau */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.sign-btn:hover {
  background: #1e7e34; /* Hijau lebih gelap saat hover */
}

.fullscreen-loading {
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-wrapper {
  text-align: center;
}

#tabungan-info-icon:hover {
  transform: scale(1.3);
  transition: color 0.3s ease, transform 0.3s ease;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: max-content;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1;
  bottom: 120%; /* posisi di atas tombol */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
}

.tooltip-wrapper.show-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.custom-btn-modal {
  background-color: #00A1CA;
  color: white;
  border-radius: 10px;
  padding: 10px 25px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
  font-weight: 600;
  font-size: 16px;
}

.custom-btn-modal:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.error-text {
  color: red;
  font-size: 13px;
  margin-top: 5px;
}
.input-style {
  font-size: 18px;
  background-color: #ffffff;
  border: 1px solid #6c6d70;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
  width: 80%;
  text-align: center;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 30px;
}
.modal-action-buttons.no-rekening {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.custom-btn {
  background-color: #00A1CA;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn.primary:disabled,
.custom-btn.primary[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.danger:disabled,
.custom-btn.danger[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.rekening {
  background-color: #00A1CA;
  color: white !important;
  padding: 0.5rem 1.5rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 400;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  background-color: #008bb0;
}

.custom-btn.primary {
  background-color: #00A1CA;
}

.custom-btn.danger {
  background-color: #00A1CA;
}

.detail-product-card {
  padding: 25px 30px;
  border: 1px solid #6c6d70;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-label {
  gap: 20px;
}

.text-label {
  font-size: 20px;
  text-transform: uppercase;
  color: #13346c;
  font-weight: 500;
}

.title-modal{
  font-size: 20px;
  color: #274C8E;
  font-weight: 500;
}

.text-value {
  font-size: 18px;
  color: #6c6d70;
  font-weight: 400;
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-blue {
  padding: 15px 25px;
  background-color: #00a1ca;
  color: white;
  font-weight: 500;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
  font-size: 18px;
  width: fit-content;
  margin: 35px auto;
}

.button-blue:hover {
  transform: scale(105%);
}

.preview-wrapper {
  gap: 10px;
}

.preview-item {
  position: relative;
  width: 240px;   /* kotak lebih besar */
  height: 240px;  /* kotak lebih besar */
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid #ddd;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* bukan cover */
  display: block;
  background: #f9f9f9; /* kasih background biar rapi kalau ada ruang kosong */
}

.preview-item .remove-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

/* Responsive untuk layar kecil */
@media (max-width: 576px) {
  .preview-item {
    width: 70px;
    height: 70px;
    margin: 3px;
  }
  .preview-item .remove-btn {
    width: 16px;
    height: 16px;
    font-size: 12px;
    line-height: 16px;
  }

  .custom-btn {
    font-size: 14px !important;   /* kecilkan ukuran font */
    padding: 0.5rem 1rem !important; /* kecilkan padding */
    min-width: auto !important;   /* biar fleksibel */
  }

  .custom-btn.rekening {
    font-size: 14px !important;
    padding: 0.4rem 0.8rem !important;
    min-width: auto !important;
  }

  .modal-action-buttons {
    gap: 10px; /* rapatkan tombol */
    padding: 0 15px; /* biar nggak terlalu mepet */
  }

  .modal-action-buttons.no-rekening {
    gap: 10px;
    padding: 0 15px;
  }
}

/* Responsive untuk tablet & HP */
@media (max-width: 1024px) {
  .input-style {
    font-size: 18px;
    background-color: #ffffff;
    border: 1px solid #6c6d70;
    border-radius: 10px;
    padding: 7px;
  }
  .text-label {
    font-size: 12px;
  }

  .text-value {
    font-size: 18px;
  }

  .button-blue {
    font-size: 16px;
  }
}  

</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/pengajuan.vue